import mixpanel from 'mixpanel-browser';
import Config from '../config/config';

mixpanel.init(Config.MIXPANEL_TOKEN);

const environment = Config.ENV;

const actions = {
  identify: (id: any) => {
    environment === 'prod' && mixpanel.identify(id);
  },
  alias: (id: any) => {
    environment === 'prod' && mixpanel.alias(id);
  },
  track: (event: any, props?: any) => {
    environment === 'prod' && mixpanel.track(event, props);
  },
  people: {
    set: (props: any) => {
      environment === 'prod' && mixpanel.people.set(props);
    },
  },
};

export const Mixpanel = actions;